import React, {useState} from 'react'
import styled from "@emotion/styled/macro"
import { keyframes } from '@emotion/react'
import { theme, device } from "./Theme"
import SvgRedHeaderSvg from "../images/SVGs/RedHeaderSvg"
import SvgPhoneIcon from "../images/SVGs/PhoneIcon"
import SvgRightArrow from "../images/SVGs/RightArrow"
import { NavDesktop } from './NavDesktop'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import SvgWhiteHeaderSvg from '../images/SVGs/WhiteHeaderSvg'
import { ReviewsWidgetCircleLeft } from './ReviewsWidgetCircleLeft'
import { HeaderTextBottom } from './HeaderTextBottom'
import { CustomModal } from './CustomModal'
import { Form } from './Form'



const HeaderDesktop = (props) =>{
 
  const hvrWobbleSkew = keyframes`
  16.65% {
    transform: skew(-12deg);
  }
  33.3% {
    transform: skew(10deg);
  }
  49.95% {
    transform: skew(-6deg);
  }
  66.6% {
    transform: skew(4deg);
  }
  83.25% {
    transform: skew(-2deg);
  }
  100% {
    transform: skew(0);
  }
  `
  const HeaderDesktopOuterContainer = styled.div`
  display: none;
  @media ${device.lg}{
    display: block;
  }
  `

  const HeaderDesktopContainer = styled.div`
 
    display: grid;
    grid-template-columns: 1fr 2.5fr 1fr;
    grid-template-rows: 1fr 1fr;
    position: relative;
  

  .logoSvgContainer{
    display: block;
background: linear-gradient(to bottom, ${theme.colors.dark} 50%, ${theme.colors.gray} 0%);
position: relative;
line-height: 0;
grid-row: 1 / span 2;

svg{
  max-width: 100%;
  height: 100%;
}
.logoContainer{
    position: absolute;
top: 50%;
left: clamp(1rem, -14.8039rem + 25.4902vw, 7.5rem);
transform: translate(0, -50%);
max-width: 70%;

@media (min-width: 1150px){
  max-width: 60%;
}
  }
  .gatsbyImageContainerNoTransition{
    .gatsby-image-wrapper [data-main-image] {
  transition: none;
  pointer-events: none;
}
  }
}
 
 
  .svgPhoneButtonContainer{
    background: linear-gradient(to bottom, ${theme.colors.dark} 50%, ${theme.colors.gray} 0%);
position: relative;
grid-row: 1 / span 2;
display: flex;
justify-content: end;
svg{
  max-width: 100%;
  height: 100%;
}
  }
  .phoneButtonContainer{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 1.8125rem;
    width: 75%;
  }
  .phoneSvgAndNumberContainer{
    display: flex;
    grid-column-gap: clamp(0.2rem, -0.4547rem + 1.0560vw, 0.8125rem);
    color: ${theme.colors.light};
    font-weight: 800;
    font-size: clamp(0.75rem, 0.5073rem + 1.0356vw, 1.75rem);
    align-items: center;
    margin-bottom: clamp(0.2rem, -1.1897rem + 2.2414vw, 1.5rem);
    transition: color 0.25s;
    justify-content: center;

    &:hover, &:active{
      color: ${theme.colors.secondary};
      & path {
    fill: ${theme.colors.secondary};
  }
      svg{
      animation: ${hvrWobbleSkew} 1s ease-in-out 1;
      }
    }

    svg{
      transform: perspective(1px) translateZ(0);
    }
  }
  .actionButton{
    display: flex;
    column-gap: 1.0625rem;
    color: ${theme.colors.light};
    background-color: ${theme.colors.dark};
    padding: clamp(0.5rem, -3.6731rem + 6.7308vw, 1.375rem) clamp(0.5rem, -8.4423rem + 14.4231vw, 2.375rem);
    font-family: ${theme.fonts.altFont};
    font-size: clamp(0.75rem, -0.0098rem + 1.2255vw, 1.0625rem);
    font-weight: 700;
    letter-spacing: 1px;
    appearance: none;
    border: none;
    text-transform: uppercase;
    align-items: center;
    margin: 0 auto;
    transform: perspective(1px) translateZ(0);
  position: relative;
  transition-property: color;
  transition-duration: 0.3s;
  &:before{
    content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${theme.colors.secondary};
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition-property: transform;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  }
&:hover:before, &:active:before{
  transform: scaleX(1);
}
    &:hover, &:active{
      cursor: pointer;
      color: ${theme.colors.dark};
      & path {
    fill: ${theme.colors.dark};
  }
    }
  }
  .topBar{
   
   background-color: ${theme.colors.dark};
   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: 1rem;

   ul{
    list-style: none;
    margin-block-start: 0;
    margin-block-end: 0;
    display: flex;
    gap: 1.375rem;
    margin-left: 2.875rem;
    text-transform: uppercase;
    font-size: clamp(0.75rem, 0.4461rem + 0.4902vw, 0.875rem);
   font-weight: 300;
   }
   li{
     display: inline-block;
   }
   a{
     color: ${theme.colors.light};
   }
 
  }
  `
 
 const [isModalOpen, setIsModalOpen] = useState(false)

    return(
<HeaderDesktopOuterContainer>
        <HeaderDesktopContainer>
        <Link className="logoSvgContainer" to="/">
            <div className='logoContainer'>
              <div className='gatsbyImageContainerNoTransition'>
              <GatsbyImage image={props.headerData.logo} loading="eager" alt="logo" />
              </div>
            </div>
          <SvgWhiteHeaderSvg />
          </Link>
          <div className="topBar">
        <ul>
{props.topBarMenuItems.map(item =>{
return(
<li key={item.index}>
<Link to={item.path}>
{item.label}
</Link>
</li>
)
})}
</ul>
<ReviewsWidgetCircleLeft data={props.ratingsValues} instance={1} />
</div>

   <div className='svgPhoneButtonContainer'>
     <SvgRedHeaderSvg />
   <div className="phoneButtonContainer">
     <a href={`tel:`+props.headerData.phoneNumber} className="phoneSvgAndNumberContainer">
     <SvgPhoneIcon />
   <p>
   {props.headerData.phoneNumber}
   </p>
     </a>
  

<button 
className='actionButton'
onClick={() => setIsModalOpen(true)}
>
 <p>
 {props.buttonText.buttonText}
 </p>
   <SvgRightArrow />
</button>
   </div>

     </div>  
    
   <NavDesktop mainMenuItems={props.mainMenuItems} dropdownImages={props.dropdownImages} megaMenuButtons={props.megaMenuButtons} formData={props.formData} buttonText={props.buttonText.buttonText} />
        
       
       </HeaderDesktopContainer>
       <HeaderTextBottom headerData={props.headerData} />
       <CustomModal onClose={() => setIsModalOpen(false)} isModalOpen={isModalOpen} modalContent={<Form data={props.formData} />} />
       </HeaderDesktopOuterContainer>
    )
}

export { HeaderDesktop }